import '../../../../../base/browser/dom.js';
import '../../../../../base/common/lifecycle.js';
import '../../../../../base/common/arrays.js';
import '../../../../../base/common/observableInternal/derived.js';
import '../../../../../base/common/observableInternal/autorun.js';
import '../../../../../base/common/observableInternal/utils.js';
import '../../../../../base/common/cancellation.js';
import '../model/lineRange.js';
import '../../../../../nls.js';
const conflictMarkers = {
    start: '<<<<<<<',
    end: '>>>>>>>',
};
export { conflictMarkers };
